import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDvrRecordings } from 'store/actions';

export function useRecordingsDvrSlider() {
	const dispatch = useDispatch();

	const {
		data: recordings,
		isLoaded: areRecordingsLoaded,
		isError,
		errorMessage
	} = useSelector((store) => store.recordingsDvr);

	const { selectedDevice, data: devices } = useSelector(
		(store) => store.devices
	);

	useEffect(() => {
		const deviceId =
			!selectedDevice && devices.length > 0 ? devices[0].id : selectedDevice;
		if (deviceId) fetchDvrRecordings(deviceId)(dispatch);
	}, [dispatch, devices, selectedDevice]);

	return {
		areRecordingsLoaded,
		recordings,
		isError,
		errorMessage
	};
}
